import { IGenericAnalysis, isUndefinedOrNull, labels } from "./omnia"
import { IAnalysisValueColumn } from "./types"

export function formatAnalysisValue(analysis: IGenericAnalysis, column: IAnalysisValueColumn): any {

    if (!analysis) return null

    let value = analysis[column.name]
    if (isUndefinedOrNull(value)) return value

    if (column.formatter) {
        return column.formatter(value)
    }

    if (column.units == "%") {
        const decimals = column.key == "OrganicMatter" ? 1 : 0
        value = formatPct(value, decimals)
    }

    return value

}

export function formatPct(value: number, decimals: number) {

    if (isUndefinedOrNull(value)) {
        return
    }

    const mul = Math.pow(10, decimals + 2)
    const div = Math.pow(10, decimals)

    const text = (Math.round(value * mul) / div).toString() + " %"

    return text

}

export function formatP2O5Method(value: number) {
    return labels.SoilP2O5Method(value)
}
